document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-swyft-product]").forEach((root) => {
    const openButton = root.querySelector("[data-swyft-open]");
    const drawer = root.querySelector("[data-swyft-drawer]");
    const overlay = root.querySelector("[data-swyft-overlay]");
    const closeButton = root.querySelector("[data-swyft-close]");
    const form = root.querySelector("[data-swyft-form]");
    const input = root.querySelector("[data-swyft-input]");
    const sendButton = root.querySelector("[data-swyft-send]");
    const messages = root.querySelector("[data-swyft-messages]");
    const suggestions = root.querySelector("[data-swyft-suggestions]");
    const productJson = root.querySelector("[data-swyft-product-json]");

    const mode = root.dataset.swyftMode || "product";
    const endpoint = root.dataset.endpoint;

    let product = null;

    if (mode === "product") {
      if (!productJson) {
        console.error("Swyft product data is missing.");
        return;
      }

      try {
        product = JSON.parse(productJson.textContent);
      } catch (error) {
        console.error("Swyft product data could not be parsed:", error);
        return;
      }
    }

    function openDrawer() {
      drawer.hidden = false;
      overlay.hidden = false;
      document.body.classList.add("swyft-product-open");

      requestAnimationFrame(() => {
        drawer.classList.add("is-open");
        overlay.classList.add("is-visible");
      });

      setTimeout(() => {
        const canHover =
          window.matchMedia(
            "(hover: hover) and (pointer: fine)"
          ).matches;

        if (canHover) {
          input.focus();
        }
      }, 320);
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-visible");
      document.body.classList.remove("swyft-product-open");

      setTimeout(() => {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 320);

      openButton.focus();
    }

    function addMessage(text, type, loading = false) {
      const message = document.createElement("div");

      message.className = `swyft-message swyft-message--${type}`;

      if (loading) {
        message.classList.add("swyft-message--loading");
      }

      message.textContent = text;
      messages.appendChild(message);

      const content = root.querySelector("[data-swyft-content]");
      content.scrollTop = content.scrollHeight;

      return message;
    }

    function renderSuggestions(items = []) {
      suggestions.innerHTML = "";
      items.slice(0, 3).forEach((question) => {
        const button = document.createElement("button");

        button.type = "button";
        button.textContent = question;
        button.dataset.swyftSuggestion = question;

        suggestions.appendChild(button);
      });
    }
    function buildSwyftSearchUrl(data) {
  // Supports either:
  // data.search = structured search object
  // OR the structured fields being returned directly on data
  const search = data?.search || data;

  const params = new URLSearchParams();

  const query =
    typeof search.searchQuery === 'string'
      ? search.searchQuery.trim()
      : '';

  if (query) {
    params.set('q', query);
  }

  params.set('options[prefix]', 'last');
  params.set('sort_by', 'relevance');

  /*
   * Brand = hard Shopify vendor filter
   */
  if (
    typeof search.brand === 'string' &&
    search.brand.trim()
  ) {
    params.set(
      'filter.p.vendor',
      search.brand.trim()
    );
  }

 /*
 * Product type = hard Shopify product type filter
 */
if (
  typeof search.productType === 'string' &&
  search.productType.trim()
) {
  params.set(
    'filter.p.product_type',
    search.productType.trim()
  );
}

  /*
   * Price constraints
   */
  if (
    typeof search.minPrice === 'number' &&
    Number.isFinite(search.minPrice)
  ) {
    params.set(
      'filter.v.price.gte',
      String(search.minPrice)
    );
  }

  if (
    typeof search.maxPrice === 'number' &&
    Number.isFinite(search.maxPrice)
  ) {
    params.set(
      'filter.v.price.lte',
      String(search.maxPrice)
    );
  }

  /*
   * Shopify still expects q on a search page.
   * "*" gives us a broad catalog search when Swyft has
   * structured filters but no useful text query.
   */
  if (!params.has('q')) {
    params.set('q', '*');
  }

  return `/search?${params.toString()}`;
}
    async function askSwyft(question) {
    const cleanQuestion = question.trim();

    if (!cleanQuestion) return;

    addMessage(cleanQuestion, "user");

    input.value = "";
    input.disabled = true;
    sendButton.disabled = true;

    renderSuggestions([]);

    const loadingMessage = addMessage(
      "Swyft is thinking…",
      "assistant",
      true
    );

    try {
      let payload;

      if (mode === "search") {
        const originalQuery =
          sessionStorage.getItem("swtekExploreOriginalQuery");

        if (!originalQuery) {
          throw new Error(
            "Original Swyft search query is missing."
          );
        }

        payload = {
          query: originalQuery,
          refinement: cleanQuestion,
        };
      } else {
        payload = {
          question: cleanQuestion,
          product,
        };
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      loadingMessage.remove();

      if (!response.ok) {
        throw new Error(
          data.message ||
          data.error ||
          "Request failed"
        );
      }

      if (mode === "product" && !data.ok) {
        throw new Error(
          data.message ||
          data.error ||
          "Request failed"
        );
      }


      /* ------------------------------
        SEARCH MODE
      ------------------------------ */

      if (mode === "search") {

        if (data.action === "answer") {
          addMessage(
            data.answer ||
            "I couldn't find an answer for that.",
            "assistant"
          );

          renderSuggestions(
            data.suggestions || []
          );

          return;
        }


        if (data.action === "clarify") {
          addMessage(
            data.question ||
            "Could you clarify what you're looking for?",
            "assistant"
          );

          renderSuggestions(
            data.suggestions || []
          );

          return;
        }


        if (data.action === "search") {
        console.log(
          "Swyft refined search:",
          data
        );

        // Tell the destination search page
        // to scroll down to the results grid.
        sessionStorage.setItem(
          "swtekExploreSearch",
          "true"
        );

        // Keep track of this as a Swyft-generated result page.
        sessionStorage.setItem(
          "swtekExploreResults",
          "true"
        );

        const searchUrl =
          buildSwyftSearchUrl(data);

        window.location.href =
          searchUrl;

        return;
      }


        throw new Error(
          "Swyft returned an unknown search action."
        );
      }


      /* ------------------------------
        PRODUCT MODE
      ------------------------------ */

      addMessage(
        data.answer,
        "assistant"
      );

      renderSuggestions(
        data.suggestions || []
      );

    } catch (error) {
      loadingMessage.remove();

      console.error(
        "Ask Swyft error:",
        error
      );

      addMessage(
        "Sorry, I couldn't answer that right now. Please try again.",
        "assistant"
      );
    } finally {
      input.disabled = false;
      sendButton.disabled = false;
      const canHover =
      window.matchMedia(
        "(hover: hover) and (pointer: fine)"
      ).matches;

      if (canHover) {
        input.focus();
      }
    }
  }

    openButton.addEventListener("click", openDrawer);
    closeButton.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      askSwyft(input.value);
    });

    suggestions.addEventListener("click", (event) => {
      const button = event.target.closest("[data-swyft-suggestion]");

      if (!button) return;

      askSwyft(button.dataset.swyftSuggestion);
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });
  });
});